import { EMessagesLoadReason } from '../../types/messagesLoadReason';
import { ETelemetryEvents } from '../../types/telemetry';

// переменная используется для отслеживания события первого сообщения
export const HISTORY_MESSAGES_REQUEST_LIMIT = 100;

export const DEFAULT_ERROR_MESSAGE = 'Ошибка при получении сообщений чата';

export const MESSAGES_GET_TELEMETRY_EVENTS: Record<
  EMessagesLoadReason,
  Record<'init' | 'success' | 'time' | 'fail', ETelemetryEvents>
> = {
  [EMessagesLoadReason.Regular]: {
    init: ETelemetryEvents.MessagesGetRegularInit,
    success: ETelemetryEvents.MessagesGetRegularSuccess,
    time: ETelemetryEvents.MessagesGetRegularTime,
    fail: ETelemetryEvents.MessagesGetRegularFail,
  },
  [EMessagesLoadReason.Sync]: {
    init: ETelemetryEvents.MessagesGetSyncInit,
    success: ETelemetryEvents.MessagesGetSyncSuccess,
    time: ETelemetryEvents.MessagesGetSyncTime,
    fail: ETelemetryEvents.MessagesGetSyncFail,
  },
  [EMessagesLoadReason.ReplyScroll]: {
    init: ETelemetryEvents.MessagesGetReplyScrollInit,
    success: ETelemetryEvents.MessagesGetReplyScrollSuccess,
    time: ETelemetryEvents.MessagesGetReplyScrollTime,
    fail: ETelemetryEvents.MessagesGetReplyScrollFail,
  },
};
